import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-blog-one',
  templateUrl: './blog-one.component.html',
  styleUrls: ['./blog-one.component.scss']
})
export class BlogOneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
